import type { IncomeInsuranceSigningPageLogic } from 'models';
import { createContext } from 'react';

export const SigningPageContext = createContext(
  {} as IncomeInsuranceSigningPageLogic,
);
